webpackJsonp([210738192975785],{

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _emotion = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsPage = function MapsPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "h1",
	      null,
	      "Map Cards"
	    ),
	    _react2.default.createElement(
	      "div",
	      {
	        className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("display:grid;grid-template-columns:repeat(auto-fit,minmax(330px,1fr));grid-gap:1.0875rem;")
	      },
	      data.allMapsJson.edges.map(function (_ref2) {
	        var node = _ref2.node;
	        return _react2.default.createElement(
	          "div",
	          {
	            key: node.name,
	            className: /*#__PURE__*/ /*#__PURE__*/(0, _emotion.css)("text-align:center;")
	          },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/map/" + node.slug },
	            _react2.default.createElement("img", {
	              src: "//res.cloudinary.com/rgdelato/image/fetch/f_auto/http://codexcards-assets.surge.sh/images/" + node.filename,
	              alt: node.name,
	              width: "330",
	              height: "450"
	            })
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = MapsPage;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-maps-js-e310eaba759ee1ff1df7.js